import React from 'react';

import { EnvironmentContext } from '@embeds/core/EnvironmentContext';
import { AnalyticsProvider } from './AnalyticsContext';
import { EnvironmentProvider } from './EnvironmentContext';

export const EmbedProvider = ({ data, children }) => {
  return (
    <EnvironmentContext.Consumer>
      {(envData) => (
        <AnalyticsProvider data={data} envData={envData}>
          <EnvironmentProvider envData={envData}>
            {children}
          </EnvironmentProvider>
        </AnalyticsProvider>
      )}
    </EnvironmentContext.Consumer>
  );
};
